import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  claimModal: false,
  timeSlotModal: false,
  referralSuccModal: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    handleClaimModal: (state, action) => ({
      ...state,
      claimModal: action.payload,
    }),
    handleTimeSlotModal: (state, action) => ({
      ...state,
      timeSlotModal: action.payload,
    }),
    handleReferralSuccModal: (state, action) => ({
      ...state,
      referralSuccModal: action.payload,
    }),
  },
});

export const {
  handleClaimModal,
  handleTimeSlotModal,
  handleReferralSuccModal,
} = modalSlice.actions;
export default modalSlice;
